import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ReactionCitations from '@Components/Results/reactions/reaction-details/ReactionCitations';

export default class CitationCell extends React.PureComponent {

  render() {
    const { metadata, citations } = this.props;

    return (
      <>
        {citations.map((citation, citationIndex) => (
          <ReactionCitations
            key={citationIndex}
            metadata={metadata}
            index={citationIndex}
            citation={citation}
            isSubstances={true}
          />
        ))}
      </>
    );
  }
}

CitationCell.propTypes = {
  metadata: MetadataPropTypesShape,
  citations: PropTypes.array.isRequired,
};
